import React, { memo } from 'react';
import PropTypes from 'prop-types';
import H2 from '../../../components/H2';
import Title from '../../../components/Title';
import { LayoutContent } from '../../../components/Layout';

const StepTitles = ({ title, subtitle }) => {
  return (
    <LayoutContent>
      <H2>{title}</H2>
      <div>
        <Title size="big">{subtitle}</Title>
      </div>
    </LayoutContent>
  );
};

StepTitles.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default memo(StepTitles);
